import React from "react";
import "./App.css";
import { Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import { Provider } from "./components/ui/provider";
import Ecard from "./pages/Ecard";

function App() {
  return (
    <Provider>      
        <Routes>
          <Route path="/" element={<Home />} />
          <Route
            path="/card/:id"
            element={ <Ecard />
            }
          />
        </Routes>
    </Provider>
  );
}

export default App;
